<template>
	<div class="body">
		<Header></Header>
		<div class="block">
			<div class="banner_news"></div>
			<div class="menu_block">
				<div class="content fsb">
					<div class="location">
						当前位置：
						<a href="/">首页</a>
						<i class="icon el-icon-arrow-right"></i>
						<a href="">新闻中心</a>
						<i class="icon el-icon-arrow-right"></i>
						<a href="">公司新闻</a>
					</div>
				</div>
			</div>

			<div class="content">
				<div class="news_detail">
					<div class="title">
						<strong>进入中石化供应商体系</strong>
						<span>发布日期：2022年8月19日</span>
					</div>
					<div class="text" style="text-align: center">
						<p><img src="../images/news/gongyingshang.png" alt=""/></p>
					</div>
				</div>

				<div class="news_link">
<!--					<a class="prev" href=""><i class="el-icon-arrow-left"></i>上一条</a>-->
					<a class="menu" href="/news"><i class="el-icon-s-grid"></i>返回列表</a>
<!--					<a class="next" href=""><i class="el-icon-arrow-right"></i>下一条</a>-->
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
import Header from '../components/hearder.vue'
import Footer from '../components/footer.vue'
export default {
components: {
	Header,
	Footer
},
}
</script>

<style lang="less" scoped>
.news_detail{
	width: 100%;
	margin-top: 60px;

	.title{
		width: 100%;
		border-bottom: 1px solid #ececec;
		padding-bottom: 30px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		strong{
			color: #000;
			font-size: 38px;
		}
		span{
			color: #666;
			font-size: 16px;
			margin-top: 20px;
		}
	}
	.text{
		font-size: 16px;
		width: 100%;
		line-height: 32px;
		margin-top: 40px;

		img{
			max-width: 100%;
		}
	}
}
.news_link{
	font-size: 16px;
	width: 100%;
	height: 60px;
	background: #f9f9f9;
	border-radius: 5px;
	padding:0 30px;
	margin-top: 50px;
	display: flex;
	justify-content: space-between;
	align-items: center;

	a{
		color: #666;

		i{
			color: #666;
			margin-right: 5px;
		}
	}
}
</style>